import {gql} from '@apollo/client';

import {QuestionTypeEnum as QuestionType} from '#apollo/schema';

import {LongTextQuestion, MultipleChoiceQuestion, NumberQuestion, ShortTextQuestion} from '..';

import {QuestionProps} from './Question.types';

export const surveyQuestionFragment = gql`
  fragment SurveyQuestionFragment on Question {
    id
    description
    questionType
    text
    multipleChoiceConfiguration {
      questionChoiceType
      options {
        id
        text
      }
    }
    longTextConfiguration {
      placeholder
      minLength
      maxLength
      defaultValue
    }
  }
`;

export const Question = ({question, onNext, onBack, surveyId}: QuestionProps) => {
  const {questionType} = question;
  const questionProps = {question, onNext, onBack};

  if (questionType === QuestionType.ShortTextEnum) {
    return <ShortTextQuestion surveyId={surveyId} {...questionProps} />;
  } else if (questionType === QuestionType.LongTextEnum) {
    return <LongTextQuestion surveyId={surveyId} {...questionProps} />;
  } else if (questionType === QuestionType.MultipleChoiceEnum) {
    return (
      <MultipleChoiceQuestion
        options={question?.multipleChoiceConfiguration?.options}
        surveyId={surveyId}
        {...questionProps}
      />
    );
  } else if (questionType === QuestionType.NumericEnum) {
    return <NumberQuestion surveyId={surveyId} {...questionProps} />;
  } else {
    return null;
  }
};
